<template>
  <div id="print-report">
    <!-- PRINT ONLY -->
    <div class="caption d-none d-print-block mb-3">
      <HeaderPrint />
      <div>
        {{ $t("FilteredPeriod") }}:
        {{ $date.formatRange(rangeDate) }}
      </div>
    </div>
    <!-- end/ PRINT ONLY -->
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="6" md="9">
            <v-btn
              small
              class="white black--text d-print-none"
              @click="$printReport()"
            >
              <v-icon small left> mdi-printer </v-icon>
              {{ $t("print") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="d-md-none">
            <div class="text-right">
              <v-btn-toggle dense>
                <v-btn @click="breakpoint = 0">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>
                <v-btn @click="breakpoint = 'xs'">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="data"
        item-key="name"
        class="elevation-1 mb-3"
        :search="search"
        :dense="$vuetify.breakpoint.smAndDown"
        :mobile-breakpoint="breakpoint"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.id_sale="{ item }">
          <v-btn @click="$copy(item.id_sale)" x-small>{{ item.id_sale }}</v-btn>
        </template>

        <template v-slot:item.date_sales="{ item }">
          <span class="caption">{{ item.date_sales }}</span>
        </template>

        <template v-slot:item.value_sale="{ item }">
          <div class="green--text">{{ item.value_sale }}</div>
        </template>
        <template v-slot:item.value_comission="{ item }">
          <div class="red--text">{{ item.value_comission }}</div>
        </template>

        <template v-slot:item.status_sales="{ item }">
          <v-chip
            small
            outlined
            :color="item.status_sales == 1 ? 'green' : 'purple'"
            v-html="item.status_sales == 1 ? 'Ok' : $t('canceled')"
          ></v-chip>
        </template>
      </v-data-table>
    </v-card>
    <!-- RESUME -->
    <div class="mt-4" v-if="resume != ''">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">{{ $t("resumeSummary") }}
              <div class="caption"> {{$store.state.rangeUI}}</div>
            </div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, i) in resume" :key="i">
                    <td>{{ item.label }}</td>
                    <td :class="getColor(item.value, i)" class="text-right">
                      {{ item.value }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";

export default {
  components: {
    HeaderPrint,
  },
  name: "local-manager-bet-historic",
  data: () => ({
    breakpoint: "xs",
    data: [],
    search: "",
    resume: "",
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    status() {
      return this.$store.state.filters.groupStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        { text: this.$t("code"), value: "id_sale" },
        { text: this.$t("seller"), value: "name_seller" },
        { text: this.$t("player"), value: "name_player" },
        { text: this.$t("operation"), value: "name_operation" },
        { text: this.$t("dateLabel"), value: "date_sales" },
        { text: this.$t("valueLabel"), value: "value_sale" },
        { text: this.$t("commissionSales"), value: "value_comission" },
        { text: this.$t("status"), value: "status_sales" },
      ];
    },
  },

  watch: {
    saveFilters(val) {
      val && this.requestApi();
    },
  },

  methods: {
    resetPage() {
      this.search = "";
    },

    async requestApi() {
      this.resetPage();
      const body = {
        ...this.rangeDate,
        status: this.status,
        id_agente: this.id_agent,
      };
      const request = await this.$request.post(
        "/localManager/credits/historicSales",
        body
      );
      this.data = request.length == 0 ? [] : request.dados;
      this.data.forEach((item) => {
        item.date_sales = new Date(
          item.date_sales.replace(" ", "T")
        ).toLocaleString();
      });
      // Build Resume
      this.buildResume(this.data);
    },

    // Construindo o Resumo:
    buildResume(data) {
      // Obj para armazenar os somatórios
      const sum = [
        { label: this.$t("sales"), value: data.length },
        { label: this.$t("value"), value: 0 },
        { label: this.$t("commissionSales"), value: 0 },
        { label: "TOTAL", value: 0 },
      ];

      // Iterando e somando os valores
      data.forEach((element) => {
        // Soma Vendas:
        sum[1].value = sum[1].value + Number(element.value_sale);
        // Soma Comissão:
        sum[2].value = sum[2].value + Number(element.value_comission) * -1;
        // Soma Total:
        sum[3].value =
          sum[3].value +
          (Number(element.value_sale) + Number(element.value_comission) * -1);
      });

      // toFixed(2)
      this.resume = sum.map((element, index) => {
        return {
          label: element.label,
          value: index == 0 ? element.value : element.value.toFixed(2),
        };
      });

      // console.log(this.resume);
    },

    getColor(value, index) {
      if (value == 0 || index == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
